import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

function TodayLeave({ leaves = [] }) {
  const cardStyle = {
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
    marginBottom: "20px",
  };

  const rowStyle = {
    padding: "8px 0",
    borderBottom: "1px solid #f0f0f0",
  };

  const headerStyle = {
    fontWeight: "600",
    borderBottom: "2px solid #dee2e6",
    paddingBottom: "8px",
  };





  return (
    <Card style={cardStyle}>
      <Card.Header className="bg-primary text-white">
        <strong>Today's Leave</strong>
      </Card.Header>
      <Card.Body>
        {leaves.length === 0 ? (
          <div className="text-muted">No employees on leave today.</div>
        ) : (
          <div>
            <Row style={headerStyle} className="text-muted small">
              <Col sm={6}>EMP Id</Col>
              <Col sm={6}>Employee Name</Col>
            </Row>
            {leaves.map((leave, index) => (
              <Row key={index} style={rowStyle}>
                <Col sm={6}>{leave.employeeId}</Col>
                <Col sm={6}>{leave.employeeName}</Col>
              </Row>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default TodayLeave;
